module.exports = __webpack_public_path__ + "static/media/damage-green.6c043c02.svg";